import aboutBoardImage from '../../assets/images/about/plurato-sailfin-efoil-bw-bars.png';
import "./About.scss";

function About() {

  return (
    <>
        <section id="about">
            <div className="about_row">
                <div className="about_row_text_holder">
                    {/* <div className="about_row_title">Let's get you flying!</div>
                    <div className="about_row_subtitle">
                        Are you looking to raise your game a little? Whether you’re an adventurer, sports enthusiast or an early adopter eternally searching for new thrills we've got you covered. With our <span>Plurato Sailfin</span>, chase that magical feeling while the board cuts through the water. Once you experience the feeling, you’re hooked, there’s no coming back...
                        <div className='highlight_text'>It’s incredible! It’s addictive!</div>
                    </div> */}
                    <div className="about_row_title">After 9 years, it’s time for a new chapter.</div>
                    <div className="about_row_subtitle">
                        <p>Plurato Sailfin started as an R&amp;D idea and turned into nine crazy years of designing, building, testing, improving — and flying above the water.</p>
                        <p>As of October 1, 2026, we have officially ended the production and sale of Plurato Sailfin, and we are no longer providing service or product support.</p>
                        <p>It has been one hell of a ride, and we want to thank everyone who joined us along the way — our customers, partners, friends, and everyone who ever stepped on a Sailfin.</p>
                        <p>We’re not done building things. Quite the opposite. Plurato will now be focusing on new R&amp;D projects and engineering challenges, and we’re excited to see where that takes us next.</p>
                        <p>Thank you for being part of the Sailfin story.</p>
                        <div className='highlight_text'>Thank you for flying with us.</div>
                    </div>
                </div>
                <div className="about_row_image_holder">
                    <img src={aboutBoardImage} alt={`Plurato Sailfin eFoil board`} />
                </div>
            </div>
        </section>
    </>
  );
}

export default About;
